import SecurityUtils from "@utils/security.utils";

const transform = (el, binding) => {
  if (binding.oldValue !== binding.value) {
    const config = binding.arg || {};
    el.innerHTML = SecurityUtils.sanitizeHTML(binding.value, config);
  }
};

const SafeHtmlDirective = {
  beforeMount: transform,
  updated: transform,
};

export default SafeHtmlDirective;
